import axios from 'axios';
import lib from '@/lib';

import Player from '@/classes/game/Player';

export default class PlayerModel {
	constructor() {
		this.id = null;
		this.username = 'player';
		this.sex = 'male';
		this.level = 0;
		this.stars = {
			level: 1,
			stars: {
				bronze: 3,
				silver: 2,
				gold: 0,
			},
		};
		
		this.gold = 0;
		this.silver = 0;
		this.bronze = 0;
		
		this.health = 0;
		
		this.idUnion = null;
		this.nameUnion = '';
		this.tribeId = Player.TRIBE_GAUL;
		this.spawnedOnMap = 0;
		
		this.adventurePoints = 0; // при регистрации дается 6
		this.status = Player.STATUS_IDLE;
		
		this.resBonusType = 'resourcesAll';
		
		this.deletionTime = 0;
	}
}
